import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { IMenuLink } from '../../../../models/menu-link.model';
import { AppConfigService } from '../../../../services/app-config.service';
import { UserSettingsService } from 'src/app/shared/services/rest/user-settings.service';
import { HttpHelper } from 'src/app/shared/utils/http-helper';
import { HttpResponse } from '@angular/common/http';
import { UserSettings } from 'src/app/shared/models/user-settings.model';

@Component({
  selector: 'app-application-menu',
  templateUrl: './application-menu.component.html'
})
export class ApplicationMenuComponent implements OnInit {

  /**
   * base uri of the application (brand-link)
   *
   * @type {string}
   * @memberof ApplicationMenuComponent
   */
  baseUri: string;

  /**
   * asset folder path of the application
   *
   * @type {string}
   * @memberof ApplicationMenuComponent
   */
  assetPath: string;

  /**
   * tree of menu items
   *
   * @type {IMenuLink}
   * @memberof ApplicationMenuComponent
   */
  routes: IMenuLink;

  /**
   * collapse state of the menu
   *
   * @memberof ApplicationMenuComponent
   */
  isNavbarCollapsed = true;

  constructor(private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private userSettings: UserSettingsService
  ) {
    const config = AppConfigService.settings;

    // init routes
    this.routes = { route: 'ROOT', text: 'ROOT', children: [] };
    this.routes.children.push({ route: '', text: 'a', children: [] });

    // enable 'devices' only if both active - it is start page if 'rooms' are disabled
    if (config.showDeviceReservation && config.showRoomReservation) {
      this.routes.children.push({ route: 'devices', text: 'd', children: [] });
    }

    this.routes.children.push({ route: 'my', text: 'b', children: [] });
    this.routes.children.push({
      route: 'user', text: 'user', children: [
        { route: 'logout', text: 'b', children: [] }
      ]
    });

  }

  ngOnInit() {
    this.baseUri = AppConfigService.settings.webBaseUrl;
    this.assetPath = AppConfigService.settings.assetPath;
    this.setMenuTexts(this.routes);
  }

  /**
   * set the text of the menu tree
   *
   * @private
   * @param {IMenuLink} item
   * @memberof ApplicationMenuComponent
   */
  private setMenuTexts(item: IMenuLink): void {
    item.children.forEach(element => {
      if (element.children.length > 0) {
        this.setMenuTexts(element);
      }

      if (element.text === 'user') {
        this.userSettings.getAll().toPromise().then((data: HttpResponse<UserSettings> | UserSettings) => {
          const settings = HttpHelper.getResponseData(data);
          element.text = settings.FullName;
        });

        return;
      }

      // todo: translation (the following code will not be called a second time)
      this.translate.get('MENU_' + element.route.replace('/', '_')).subscribe((text) => {
        if (text === null || text === '') {
          element.text = '[' + element.route + ']';
        } else {
          element.text = text;
        }
      });
    });
  }

  /**
   * true if the route of the given {IMenuLink} is the currently selected
   *
   * @param {IMenuLink} item
   * @returns {boolean}
   * @memberof ApplicationMenuComponent
   */
  isCurrent(item: IMenuLink): boolean {
    const firstChild = this.activatedRoute.snapshot.root.firstChild;
    if (firstChild === null) {
      return item.route === null || item.route === '';
    }
    return firstChild.routeConfig.path === item.route;
  }

  /**
   * return true if given {IMenuLink} has no children
   *
   * @param {IMenuLink} item
   * @returns {boolean}
   * @memberof ApplicationMenuComponent
   */
  hasNoChildren(item: IMenuLink): boolean {
    return item.children === null || item.children.length === 0;
  }

}
